import { AfterViewInit, Component, ElementRef, inject, signal } from "@angular/core";
import { VdsToastRef } from "../toast.ref";
import { VDS_TOAST_DATA, VdsToastType } from "../toast.config";
import { VdsIconComponent } from "@cce/design-system/icon";
import { SpinnerComponent } from "@cce/design-system/spinner";

@Component({
    selector: "vds-simple-toast",
    templateUrl: "./simple-toast.component.html",
    host: {
        class: "vds-toast"
    },
    imports: [VdsIconComponent, SpinnerComponent]
})
export class VdsSimpleToastComponent implements AfterViewInit {
    public toastRef = inject<VdsToastRef<VdsSimpleToastComponent>>(VdsToastRef);
    private elementRef = inject(ElementRef);
    private data: { message: string; action: string; type: VdsToastType } = inject(VDS_TOAST_DATA);

    /** The message to be shown in the toast. */
    message = signal<string>(this.data.message);

    /** The type of the toast. */
    type = signal<VdsToastType>(this.data.type);

    /** If the action button should be shown. */
    hasAction = signal<boolean>(!!this.data.action);

    /** The label for the action button. */
    actionLabel = signal<string>(this.data.action);

    public ngAfterViewInit(): void {
        this.applyToastTypeClasses();
    }

    /** Performs the action on the toast. */
    public action(): void {
        this.toastRef.dismissWithAction();
    }

    public dismiss(): void {
        this.toastRef.dismiss();
    }

    private applyToastTypeClasses(): void {
        const element: HTMLElement = this.elementRef.nativeElement;
        const type = this.type() === "loading" ? "info" : this.type();
        const typeClass = `vds-toast--${type}`;

        if (typeClass && element) {
            element.classList.add(typeClass);
        }
    }
}
